import { useEffect } from 'react';
const hasBody = () => {
    return typeof document !== 'undefined' && !!document.body;
};
const useUnscrollableBody = ({ shouldAllowScroll, }) => {
    useEffect(() => {
        if (hasBody()) {
            document.body.style.overflow = shouldAllowScroll ? '' : 'hidden';
        }
        return () => {
            if (hasBody()) {
                document.body.style.overflow = '';
            }
        };
    }, [shouldAllowScroll]);
};
export default useUnscrollableBody;
//# sourceMappingURL=useUnscrollableBody.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
